import React, { Component } from 'react';
import { translate } from 'react-polyglot';
import TextField from '../TextField';
import ButtonGroup from '../ButtonGroup';
import Button from '../Button';
import Modal from '../Modal';

class EditBookDetailModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      reason : ''
    };
  }

  onEditBookDetailClicked = () => {
    const {
      onEditBookDetailClicked,
      onEdit,
      onCloseClicked,
      t
    } = this.props;

    onEditBookDetailClicked(this.state.name , this.state.reason).then(response => {
      onCloseClicked()
      if (response.ok) {
        this.props.addSlimNotification({
          type: 'success',
          content: t('Book.added-details-success')
        })
        setTimeout(() => onEdit(), 3000);
      }
      else {
        this.props.addSlimNotification({
          type: 'danger',
          content: response.data.errorMessage
        })
      }
    })
  }
  onChangeEditBookNameClicked = (e) => {
    this.setState({ name: e.target.value })
  }

  onChangeEditBookReasonClicked = (e) => {
    this.setState({ reason: e.target.value })
  }

  render() {
    const {
      isVisible,
      onCloseClicked,
      viewport,
      isEditingBook,
      t,
      isRtl
    } = this.props;

    if (!isVisible) {
      return null;
    }

    const header = (
      <h2>{t('Book.add-edit-details-title')}</h2>
    );

    const disabledButton= this.state.name === '' || this.state.reason === '';

    const footer = (
      <ButtonGroup mergeTop mergeBottom={!viewport.large} mergeSides>
        <Button
          disabled={disabledButton}
          variant="primary"
          fullWidth
          label={t('global.submit')}
          onClick={this.onEditBookDetailClicked}
          loading={isEditingBook}
        />
        <Button
          fullWidth
          label={t('global.close')}
          onClick={onCloseClicked}
          disabled={false}
        />
      </ButtonGroup>
    );


    return (
      <Modal header={header} footer={footer} onClose={onCloseClicked} isRtl={isRtl}>
            {this.props.text}
        <TextField
          label={t('Book.add-edit-name-label')}
          value={this.state.name}
          fontFamily="monospace"
          onChange={this.onChangeEditBookNameClicked}
          isRtl={isRtl}
          autoFocus
        />   
        <TextField
          label={t('Book.add-edit-reason-label')}
          type="multiline"
          value={this.state.reason}
          fontFamily="monospace"
          onChange={this.onChangeEditBookReasonClicked}
          isRtl={isRtl}
        />
      </Modal>

    );
  }
};

export default translate()(EditBookDetailModal);


// WEBPACK FOOTER //
// ./src/components/Book/EditBookDetailModal.jsx